import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MobyDick4PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOBY_DICK4;
}

export default MobyDick4PoiTileEntity;
